<template>
  	<div id="historyNotice">
  		<mt-header fixed :title="$t(title)">
          	<mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
        </mt-header>
        <div class="content">
        	<mt-loadmore
				:top-method="loadTop"
				:bottom-all-loaded="allLoaded"
				:autoFill="autoFill"
				ref="loadmore"
			>
	        	<div class="box_main" v-for="(item,index) in noticeList">
					<p class="course_name">
						<span class="name wx_one_ellipsis wx_fontSize3">{{item.post_title}}</span>
						<span class="time wx_fontSize1">{{item.create_time | parseTime}}</span>
					</p>
					<p class="content_val wx_two_ellipsis wx_fontSize2">{{item.post_excerpt}}</p>
				</div>
			</mt-loadmore>
        </div>
  	</div>
</template>

<script>
import { parseTime } from '@/utils/index'
import { Toast } from 'mint-ui';
import { httpNoticeLists } from "@/api/index";
export default {
	data(){
		return{
			title:'',
			noticeList:[],
			allLoaded: false,
		    autoFill: false,
		    type:1
		}
	},
	activated(){
		this.title = this.$route.query.title;
		if(this.$route.query.title == "云端钱包公告"){
			this.type = 1;
			this.noticeLists(1);
		}else{
			this.type = 2;
			this.noticeLists(2);
		}
	},
	methods:{
		noticeLists: function(type) {
	      	httpNoticeLists({'type':type})
	        .then(res => {
	          	this.noticeList = res.data.list;
	          	this.$refs.loadmore.onTopLoaded();
	        })
	        .catch(() => {});
	    },
	    loadTop() {
	      	this.noticeLists(this.type);
	    },
	}
}
</script>
<style scoped>
#addressBook{width:100%;padding-top: 40px;}
.mint-header{background: #ffffff;color:#212529;border-bottom: 1px solid #e3e8ed;}
.mint-button--default{color:#656b79 !important;}
.content{padding: 50px 15px 0 15px;}
.box_main{border-bottom: 1px solid #eceff6;padding:0 0.25rem;}
.course_name{color:#3a405b;position: relative;}
.course_name .name{width:60%;display: inline-block;margin:8px 0;font-weight:600;}
.course_name .time{position: absolute;right:0;top:10px;color:#818496;}
.wx_one_ellipsis{white-space: nowrap;}
.content_val{color:#3a405b;line-height: 20px;margin-bottom:10px;}
</style>